import React from 'react'

const Footer = () => {
  return (
    <footer className="w-full mt-20 py-10 px-4 text-center border-t border-gray-200 dark:border-white/10 bg-white/50 dark:bg-premium-surface/50 backdrop-blur-md relative z-10">
        <small className="mb-3 block text-xs md:text-sm text-gray-500 dark:text-gray-400 font-medium tracking-wide">
            &copy; {new Date().getFullYear()} Rizwan. All rights reserved.
        </small>
        <p className="text-xs text-gray-400 dark:text-gray-500 max-w-md mx-auto leading-relaxed">
            <span className="font-semibold text-gray-600 dark:text-gray-300">About this website: </span> 
            built with React, Tailwind CSS, Framer Motion, and deployed with passion.
        </p>
    </footer>
  )
}

export default Footer;